import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const employer: AnswerPathTreeNode = {
  path: 'employer',
  children: [{ path: 'companyName', nodeId: NodeIds.insuredEmployerCompanyName }],
};
